import colorThemes from '../assets/color-themes.json';

export type Color = {
  id: string;
  color?: string;
  colors?: string[];
  angle?: number;
};

export type ColorPalette = {
  isGradient?: boolean;
  name: string;
  colors: Color[];
};

type Theme = keyof typeof colorThemes;

export const getPalette = (colorTheme?: string, numberOfColors = 4) => {
  const theme = colorTheme as Theme;
  const palette: ColorPalette =
    (theme && colorThemes[theme]) ?? colorThemes['theme-sequential-teal'];
  let colors = [];

  if (!theme?.includes('sequential')) {
    colors = palette.colors.slice(0, numberOfColors);
  } else if (numberOfColors === 2) {
    // For 2 steps, choose values 04 and 07
    colors.push(palette.colors[3]);
    colors.push(palette.colors[6]);
  } else if (numberOfColors === 3 || numberOfColors === 4) {
    // For 3-4 steps, start from 01 and skip two
    for (let index = 0; colors.length < numberOfColors; index += 3) {
      colors.push(palette.colors[index]);
    }
  } else if (numberOfColors === 5 || numberOfColors === 6) {
    // For 5-6 steps,start from 01 and skip one
    for (let index = 0; colors.length < numberOfColors; index += 2) {
      colors.push(palette.colors[index]);
    }
  } else {
    // Anything above 6 steps, use the whole sequential primitive starting from 01 / lightest
    colors = [...palette.colors].slice(0, numberOfColors);
  }

  return { ...palette, colors, isGradient: Boolean(colors[0]?.colors) };
};
